exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".half-circle-spinner[data-v-31ad46aa],.half-circle-spinner [data-v-31ad46aa]{box-sizing:border-box}.half-circle-spinner[data-v-31ad46aa]{width:60px;height:60px;border-radius:100%;position:relative}.half-circle-spinner .circle[data-v-31ad46aa]{content:\"\";position:absolute;width:100%;height:100%;border-radius:100%;border:6px solid transparent}.half-circle-spinner .circle.circle-1[data-v-31ad46aa]{border-top-color:#ff1d5e;animation:half-circle-spinner-animation-data-v-31ad46aa 1s infinite}.half-circle-spinner .circle.circle-2[data-v-31ad46aa]{border-bottom-color:#ff1d5e;animation:half-circle-spinner-animation-data-v-31ad46aa 1s infinite alternate}@keyframes half-circle-spinner-animation-data-v-31ad46aa{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31ad46aa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/epic-spinners/src/components/lib/HalfCircleSpinner.vue
// module id = 511
// module chunks = 0